import { sendErrorEvent, SentryErrorMetadata } from '@trello/error-reporting';

export const sendChunkLoadErrorEvent = (
  error: Error,
  metadata: SentryErrorMetadata = {
    tags: {},
    extraData: {},
  },
) => {
  const chunkLoadError = new Error(
    'A ChunkLoadError occurred, but it was caught and handled',
  );
  chunkLoadError.name = 'HandledChunkLoadError';
  chunkLoadError.stack = error.stack;
  sendErrorEvent(chunkLoadError, metadata);
};
